import { Task } from '../../../types/task';
import { useTaskManager } from '../../../hooks/userTaskManager';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { FinishTaskButton } from './FinishTaskButton';

interface Props {
    task: Task;
}

export function TaskItem({ task }: Props) {
    const { setOpenDetails, setCurrentTaskId, currentTaskId } = useTaskManager()

    const onOpenTaskDetails = () => {
        if(currentTaskId == task.id) return;

        setOpenDetails(true);
        setCurrentTaskId(task.id);
    }

    return (
        <div 
            onClick={onOpenTaskDetails}
            className="flex justify-between items-center border-[1px] border-gray-300 bg-slate-50 hover:bg-slate-200 rounded-md h-[55px] px-2 py-1">
            <div className="flex items-center gap-x-2">

                <FinishTaskButton 
                    taskId={task.id}
                    taskStatus={task.terminada} />

                <div>
                    <p className="font-semibold select-none">{task.titulo}</p>
                    <div className="flex items-center gap-x-1">
                        <CalendarTodayRoundedIcon sx={{ color: "rgb(17, 24, 39)", height: 13, width: 13 }}/>
                        <p className="text-[13px] select-none">{task.fechaInicial}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}